import { render, staticRenderFns } from "./default-class-course-content-visibility.vue?vue&type=template&id=388c44ec&"
import script from "./default-class-course-content-visibility.ts?vue&type=script&lang=ts&"
export * from "./default-class-course-content-visibility.ts?vue&type=script&lang=ts&"
import style0 from "./default-class-course-content-visibility.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports